import { filterPage } from "components/common/Filters/FiltersHelper";
import PlansData from "./PlansData";
import PropertiesData from "./PropertiesData";

export const tabDetails = (view: string, selectedListType: string, selectedList: any) => {
  return [
    {
      label: "Properties",
      content: Hoc(PropertiesData, view, selectedListType, selectedList),
      filtersToClear: [filterPage.listDisplay, filterPage.dashboardDisplay, filterPage.consultantListDisplay]
    },
    {
      label: "Plans",
      content: Hoc(PlansData, view, selectedListType, selectedList),
      filtersToClear: [filterPage.listDisplay, filterPage.dashboardDisplay, filterPage.consultantListDisplay]
    }
  ];
};

function Hoc(WrappedComponent: any, view: string, selectedListType: string, selectedList: any) {
  return function () {
    return <WrappedComponent view={view} selectedListType={selectedListType} selectedList={selectedList} />;
  };
}
